import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";

export default function ViewScheduleTableSalesFCT() {
  const params = PagesIndex.useParams();
  const { scheduleId, bookingId } = params;
  const location = PagesIndex.useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(
    PagesIndex.dayjs().format("YYYY-MM-DD") >
      PagesIndex.moment(state?.endDate).format("YYYY-MM-DD")
      ? PagesIndex.moment(state?.endDate)
      : PagesIndex.dayjs().format("YYYY-MM-DD") <
        PagesIndex.moment(state?.startDate).format("YYYY-MM-DD")
      ? PagesIndex.dayjs(state?.startDate)
      : PagesIndex.dayjs()
  );
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const handleGetReports = () => {
    setLoading(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append(
      "start",
      PagesIndex.moment(new Date(startDate)).format("YYYY-MM-DD")
    );
    if (bookingId) {
      urlEncoded.append("bookingId", bookingId);
    }
    PagesIndex.apiPostHandler(
      PagesIndex.Api.VIEW_SLOT_SCHEDULE + "/" + scheduleId,
      urlEncoded
    ).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        // setDataHeaders(res.data);
        setData(res.data);
        setFilteredData(res.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
    });
  };
  useEffect(() => {
    let filteredData = data.filter((data) => {
      const search = searchValue
        ? data?.currentDate
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.fromTime
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.toTime
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.adsCode
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.clientName
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.adsName
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase())
        : true;
      return search;
    });
    setFilteredData(filteredData);
  }, [searchValue]);
  const exportData = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const generateCSV = async () => {
    let headers = [];
    headers = [
      "Date",
      "Slot Timing",
      "Priority",
      "Code",
      "Client",
      "Advertisement",
      "Element",
      "Duration",
    ];
    let modifiedData = filteredData.map((data, index) => {
      let objData = [];
      objData = [
        data?.currentDate ? data?.currentDate?.replaceAll(",", "|") : "-",
        data?.fromTime && data?.toTime
          ? `${data?.fromTime}-${data?.toTime}`
          : "-",
        data?.priority
          ? data?.priority[0]?.toUpperCase() +
            data?.priority?.slice(1, data?.priority?.length)
          : "-",
        data?.adsCode ? data?.adsCode?.toString()?.replaceAll(",", "|") : "-",
        data?.clientName ? data?.clientName?.replaceAll(",", "|") : "-",
        data?.adsName ? data?.adsName?.replaceAll(",", "|") : "-",
        data?.element ? data?.element?.replaceAll(",", "|") : "-",
        data?.adsSeconds
          ? data?.adsSeconds?.toString()?.replaceAll(",", "|")
          : "-",
      ];

      return objData.join(",");
    });

    exportData(
      [[headers, ...modifiedData].join("\n")],
      `${PagesIndex.moment(new Date(startDate)).format(
        "DD-MM-YYYY"
      )}_Slot_schedule_list.csv`,
      "text/csv"
    );
  };
  const generateText = async (size) => {
    const filteredExportData = filteredData?.filter(
      (data) =>
        data?.adsCode &&
        data?.adsName &&
        data?.adsSeconds &&
        data?.clientName &&
        data?.currentDate &&
        data?.element &&
        data?.fromTime &&
        data?.noOfTimesPlay &&
        data?.priority &&
        data?.toTime &&
        data?.type
    );
    let modifiedData = filteredExportData.map((data, index) => {
      const addedSeconds = filteredExportData
        ?.filter(
          (dataInner, indexInner) =>
            dataInner?.fromTime === data?.fromTime && indexInner < index
        )
        .reduce((acc, curr) => {
          // if (
          //   acc + curr?.adsSeconds <=
          //   PagesIndex.moment(data?.toTime, "HH:mm:ss").diff(
          //     PagesIndex.moment(data?.fromTime, "HH:mm:ss"),
          //     "seconds"
          //   )
          // ) {
          return acc + curr?.adsSeconds;
          // }
        }, 0);
      let objData = [];
      objData = [
        data?.currentDate
          ? PagesIndex.moment(data?.currentDate, "DD-MM-YYYY").format(
              "DD/MM/YYYY"
            )
          : "-",
        data?.fromTime
          ? `${PagesIndex.moment(data?.fromTime, "HH:mm:ss")
              .seconds(addedSeconds)
              .format("HH:mm:ss")}`
          : "-",
        "VIDEO CLIP",
        data?.adsName ? `${data?.adsName}.mxf` : "-",
        `25.00;${size};25;192000;0\t`,
        data?.adsSeconds
          ? PagesIndex.moment()
              .startOf("day")
              .seconds(data?.adsSeconds)
              .format("HH:mm:ss")
          : "-",
        data?.adsSeconds
          ? PagesIndex.moment()
              .startOf("day")
              .seconds(data?.adsSeconds)
              .format("HH:mm:ss")
          : "-",
        data?.adsSeconds
          ? PagesIndex.moment()
              .startOf("day")
              .seconds(data?.adsSeconds)
              .format("HH:mm:ss")
          : "-",
      ];
      return objData.join(" \t");
    });

    exportData(
      [[...modifiedData].join("\n")],
      `${PagesIndex.moment(new Date(startDate)).format(
        "DD-MM-YYYY"
      )}_${size}_Slot_schedule_list.txt`,
      "text/plain"
    );
  };

  const generateXML = () => {
    const filteredExportData = filteredData?.filter(
      (data) =>
        data?.adsCode &&
        data?.adsName &&
        data?.adsSeconds &&
        data?.clientName &&
        data?.currentDate &&
        data?.element &&
        data?.fromTime &&
        data?.noOfTimesPlay &&
        data?.priority &&
        data?.toTime
    );
    // Example Data (Replace with your actual data)
    let breakCounter = 0; // Initialize a break counter
    let lastBreakTime = null;
    const dataa = filteredExportData?.map((data, index) => {
      const addedSeconds = filteredExportData
        ?.filter(
          (dataInner, indexInner) =>
            dataInner?.fromTime === data?.fromTime && indexInner < index
        )
        .reduce((acc, curr) => {
          return acc + curr?.adsSeconds;
        }, 0);
      const currentBreakTime = `${data?.fromTime}-${data?.toTime}`;
      if (currentBreakTime !== lastBreakTime) {
        breakCounter++; // Increment the break counter
        lastBreakTime = currentBreakTime; // Update the last break time
      }
      return {
        type: "ITEM",
        details: {
          itemId: data?.adsCode,
          assetId: "5781",
          clipId: `${data?.adsName}.mxf`,
          adsName: data?.adsName,
          creativeId: data?.id,
          clipDuratuinSec: data?.adsSeconds,
          clipDur: PagesIndex.moment()
            .startOf("day")
            .seconds(data?.adsSeconds)
            .format("00:HH:mm:ss"),
          planStartTime: `${PagesIndex.moment(new Date(startDate)).format(
            "YYYY-MM-DD"
          )} ${PagesIndex.moment(data?.fromTime, `HH:mm:ss`)
            .seconds(addedSeconds)
            .format("HH:mm:ss")}`,
          startTimeMin: `${PagesIndex.moment(new Date(startDate)).format(
            "YYYY-MM-DD"
          )} ${PagesIndex.moment("00:00:00", `HH:mm:ss`).format("HH:mm:ss")}`,
          startTimeMax: `${PagesIndex.moment(new Date(startDate)).format(
            "YYYY-MM-DD"
          )} ${PagesIndex.moment("23:59:59", `HH:mm:ss`).format("HH:mm:ss")}`,
          // break: `Break ${breakCounter}`,
          break: currentBreakTime,

        },
      };
    });
    // const scheduleData = {
    //   channel: "Static-NEWS365",
    //   schedStartTime: `Static-${PagesIndex.moment(new Date(startDate)).format(
    //     "YYYY-MM-DD 12:00:00"
    //   )}`,
    //   schedDur: "Static-24:00:00",
    //   schedPart: "Static-1",
    //   creatTime: PagesIndex.moment().format("YYYY-MM-DD hh:mm:ss"),
    //   items: [
    //     {
    //       type: "LIVE",
    //       itemId: "Static-5a38c2ca-5eb4-11ee-923f-38f9d36374be",
    //     },
    //     {
    //       type: "BREAK_BEGIN",
    //       itemId: "Static-63bdbe5e-5eb4-11ee-923f-38f9d36374be",
    //     },
    //     ...dataa,
    //     {
    //       type: "BREAK_END",
    //       itemId: "Static-7d6c45aa-5eb4-11ee-923f-38f9d36374be",
    //     },
    //   ],
    // };
    // const buildXML = (data) => {
    //   let xml = `<schedule>\n`;

    //   xml += `  <channel>${data.channel}</channel>\n`;
    //   xml += `  <sched-start-time>${data.schedStartTime}</sched-start-time>\n`;
    //   xml += `  <sched-dur>${data.schedDur}</sched-dur>\n`;
    //   xml += `  <sched-part>${data.schedPart}</sched-part>\n`;
    //   xml += `  <creat-time>${data.creatTime}</creat-time>\n`;
    //   xml += `  <items>\n`;

    //   data.items.forEach((item) => {
    //     if (
    //       item.type === "LIVE" ||
    //       item.type === "BREAK_BEGIN" ||
    //       item.type === "BREAK_END"
    //     ) {
    //       xml += `    <event type="${item.type}">\n`;
    //       xml += `      <item-id>${item.itemId}</item-id>\n`;
    //       xml += `    </event>\n`;
    //     } else if (item.type === "ITEM") {
    //       const details = item.details;
    //       xml += `    <item>\n`;
    //       xml += `      <item-id>${details.itemId}</item-id>\n`;
    //       xml += `      <asset-id>${details.assetId}</asset-id>\n`;
    //       xml += `      <clip-id>${details.clipId}</clip-id>\n`;
    //       xml += `      <clip-dur>${details.clipDur}</clip-dur>\n`;
    //       xml += `      <plan-start-time>${details.planStartTime}</plan-start-time>\n`;
    //       if (details.startTimeMin)
    //         xml += `      <start-time-min>${details.startTimeMin}</start-time-min>\n`;
    //       if (details.startTimeMax)
    //         xml += `      <start-time-max>${details.startTimeMax}</start-time-max>\n`;
    //       if (details.break) xml += `      <break>${details.break}</break>\n`;
    //       if (details.comment)
    //         xml += `      <comment>${details.comment}</comment>\n`;
    //       if (details.bmsData) {
    //         xml += `      <bms-data>\n`;
    //         if (details.bmsData.customTag1)
    //           xml += `        <custom-tag1>${details.bmsData.customTag1}</custom-tag1>\n`;
    //         if (details.bmsData.customTag2)
    //           xml += `        <custom-tag2>${details.bmsData.customTag2}</custom-tag2>\n`;
    //         xml += `      </bms-data>\n`;
    //       }
    //       xml += `    </item>\n`;
    //     }
    //   });

    //   xml += `  </items>\n`;
    //   xml += `</schedule>`;
    //   return xml;
    // };
    const scheduleData = {
      channel: "NEWS365",
      schedStartTime: `${PagesIndex.moment(new Date(startDate)).format(
        "YYYY-MM-DD 00:00:00"
      )}`,
      schedEndTime: `${PagesIndex.moment(new Date(startDate)).format(
        "YYYY-MM-DD 23:59:59"
      )}`,
      schedDur: "24:00:00",
      schedPart: "1",
      creatTime: PagesIndex.moment().format("YYYY-MM-DD hh:mm:ss"),
      items: [
        {
          type: "LIVE",
          itemId: "Static-5a38c2ca-5eb4-11ee-923f-38f9d36374be",
        },
        {
          type: "BREAK_BEGIN",
          itemId: "Static-63bdbe5e-5eb4-11ee-923f-38f9d36374be",
        },
        ...dataa,
        {
          type: "BREAK_END",
          itemId: "Static-7d6c45aa-5eb4-11ee-923f-38f9d36374be",
        },
      ],
    };
    const buildXML = (data) => {
      let xml = `<?xml version="1.0" encoding="utf-8"?>\n<schedule>\n`;

      xml += `  <channel>${data.channel}</channel>\n`;
      xml += `  <creat-time>${data.creatTime}</creat-time>\n`;
      xml += `  <sched-start-time>${data.schedStartTime}</sched-start-time>\n`;
      xml += `  <sched-end-time>${data.schedEndTime}</sched-end-time>\n`;
      // xml += `  <sched-dur>${data.schedDur}</sched-dur>\n`;
      xml += `  <sched-part>${data.schedPart}</sched-part>\n`;
      xml += `  <items>\n`;

      data.items.forEach((item, index) => {
        if (
          item.type === "LIVE" ||
          item.type === "BREAK_BEGIN" ||
          item.type === "BREAK_END"
        ) {
          // xml += `    <event type="${item.type}">\n`;
          // xml += `      <item-id>${item.itemId}</item-id>\n`;
          // xml += `    </event>\n`;
        } else if (item.type === "ITEM") {
          const currentDate = new Date();
          const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}${String(
            currentDate.getMonth() + 1
          ).padStart(2, "0")}${currentDate.getFullYear()}`;
          const details = item.details;
          xml += `    <item>\n`;
          xml += `      <item-id>${details.itemId}-${index}</item-id>\n`;
          xml += `      <clip-id>${details.clipId}</clip-id>\n`;
          xml += `      <data11>00:00:00</data11>\n`;
          xml += `      <data12>23:59:59</data12>\n`;
          xml += `      <data13>${details.adsName}</data13>\n`;
          xml += `      <data14>9c0e3bfa4267860${index}${formattedDate}</data14>\n`;
          xml += `      <data10>None</data10>\n`;
          xml += `      <data9>${details.clipDuratuinSec}</data9>\n`;
          xml += `      <data8>${details.creativeId}</data8>\n`;
          xml += `      <data7>BREAK</data7>\n`;
          xml += `      <data6>5c0e3bfa4257860ee1a1a382${formattedDate}${index}</data6>\n`;
          xml += `      <data5>${details.adsName}</data5>\n`;
          xml += `      <data4>None</data4>\n`;
          xml += `      <clip-dur>${details.clipDur}</clip-dur>\n`;
          xml += `      <data1>${details.clipDuratuinSec}</data1>\n`;
          xml += `      <plan-start-time>${details.planStartTime}</plan-start-time>\n`;
          xml += `      <start-time-min>${details.startTimeMin}</start-time-min>\n`;
          xml += `      <start-time-max>${details.startTimeMax}</start-time-max>\n`;
          xml += `      <comment> ${details.adsName}</comment>\n`;
          // if (details.comment)
          //   xml += `      <comment>${details.comment}</comment>\n`;
          if (details.break) xml += `      <break>${details.break}</break>\n`;
          xml += `      <data3>5b5805a4629a561dc90a20f8-${formattedDate}${index}</data3>\n`;

          // xml += `      <asset-id>${details.assetId}</asset-id>\n`;
          // if (details.startTimeMin)
          // if (details.startTimeMax)

          // if (details.bmsData) {
          //   xml += `      <bms-data>\n`;
          //   if (details.bmsData.customTag1)
          //     xml += `        <custom-tag1>${details.bmsData.customTag1}</custom-tag1>\n`;
          //   if (details.bmsData.customTag2)
          //     xml += `        <custom-tag2>${details.bmsData.customTag2}</custom-tag2>\n`;
          //   xml += `      </bms-data>\n`;
          // }
          xml += `    </item>\n`;
        }
      });

      xml += `  </items>\n`;
      xml += `</schedule>`;
      return xml;
    };
    const xmlContent = buildXML(scheduleData);

    exportData(
      xmlContent,
      `schedule_${PagesIndex.moment(new Date(startDate)).format(
        "DD-MM-YYYY"
      )}.xml`,
      "application/xml"
    );
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderTableRows = () => {
    return (
      filteredData
        // ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
        ?.map((data) => {
          const adsSeconds = filteredData
            ?.filter(
              (dataInner) =>
                dataInner?.fromTime === data?.fromTime &&
                dataInner?.toTime === data?.toTime
            )
            .reduce((acc, curr) => {
              return acc + curr?.adsSeconds;
            }, 0);
          const fromTime = PagesIndex.moment(data?.fromTime, "HH:mm:ss");
          const toTime = PagesIndex.moment(data?.toTime, "HH:mm:ss");

          // Adjust for times crossing midnight
          if (toTime.isBefore(fromTime)) {
            toTime.add(1, "day");
          }

          const diffInSeconds = toTime.diff(fromTime, "seconds");
          const isGreater = adsSeconds > diffInSeconds;
          return (
            <Index.TableRow
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#efefef",
                },
                backgroundColor: isGreater ? "#f58a8d !important" : "#ffff",
                "td p": {
                  color: isGreater ? "#fff !important" : "#000",
                },
              }}
              key={data?._id}
            >
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.currentDate || "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.fromTime && data?.toTime
                    ? `${data?.fromTime}-${data?.toTime}`
                    : "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.priority
                    ? data?.priority[0]?.toUpperCase() +
                      data?.priority?.slice(1, data?.priority?.length)
                    : "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.adsCode || "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.clientName || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.clientName || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.adsName || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.adsName || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.element || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.element || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.adsSeconds || "-"}
                </Index.Typography>
              </Index.TableCell>
            </Index.TableRow>
          );
        })
    );
  };
  const dataNotFound = () => {
    return <PagesIndex.DataNotFound />;
  };
  const renderContent = () => {
    if (filteredData?.length) {
      return renderTableRows();
    } else {
      return dataNotFound();
    }
  };
  useEffect(() => {
    handleGetReports();
  }, [startDate]);
  return (
    <Index.Box className="admin-dashboard-content admin-user-list-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          FCT Slot Schedule List
        </Index.Typography>
        <Index.Box className="admin-userlist-btn-flex">
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group" id="startDate">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderStart}
                  onClose={() => setOpenCalenderStart(false)}
                  className="admin-form-control admin-date-picker-control"
                  value={startDate}
                  minDate={PagesIndex.dayjs(state?.startDate)}
                  maxDate={PagesIndex.dayjs(state?.endDate)}
                  onChange={(date) => {
                    setStartDate(PagesIndex.moment(new Date(date)));
                  }}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: () => setOpenCalenderStart(true),
                    },
                    inputAdornment: {
                      onClick: () => setOpenCalenderStart(true), // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
          <Index.Box className="admin-search-main">
            <Index.Box className="admin-search-box">
              <Index.Box className="admin-form-group">
                <Index.TextField
                  fullWidth
                  id="fullWidth"
                  className="admin-form-control"
                  placeholder="Search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <img
                  src={PagesIndex.Svg.search}
                  className="admin-search-grey-img admin-icon"
                  alt="search"
                ></img>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          {filteredData?.length > 0 && (
            <>
              <Index.Box className="admin-adduser-btn-main btn-main-secondary">
                <Index.Button
                  className="admin-adduser-btn btn-secondary"
                  onClick={generateCSV}
                >
                  <img
                    src={PagesIndex.Svg.exporticon}
                    className="admin-plus-icon"
                    alt="plus"
                  />
                  <span>Export CSV</span>
                </Index.Button>
              </Index.Box>
              <Index.Box className="admin-adduser-btn-main btn-main-secondary">
                <Index.Button
                  className="admin-adduser-btn btn-secondary"
                  onClick={generateXML}
                >
                  <img
                    src={PagesIndex.Svg.exporticon}
                    className="admin-plus-icon"
                    alt="plus"
                  />
                  <span>Export XML</span>
                </Index.Button>
              </Index.Box>
              <Index.Box className="admin-adduser-btn-main btn-main-secondary">
                <Index.Button
                  className="admin-adduser-btn btn-secondary"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  {/* <img
                  src={PagesIndex.Svg.exporticon}
                  className="admin-plus-icon"
                  alt="plus"
                /> */}
                  <span>Export Text</span>
                  <img
                    src={PagesIndex.Svg.whiteDownIcon}
                    className="export-down-arrow"
                    alt="Down"
                  />
                </Index.Button>
              </Index.Box>
            </>
          )}
          <Index.Menu
            className="admin-drop-header-menu export-drop-menu"
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <Index.MenuItem
              className="admin-drop-header-menuitem"
              onClick={() => {
                generateText("720x576");
                handleClose();
              }}
            >
              720 x 576
            </Index.MenuItem>
            <Index.MenuItem
              className="admin-drop-header-menuitem"
              onClick={() => {
                generateText("1080x576");
                handleClose();
              }}
            >
              1080 x 576
            </Index.MenuItem>
            <Index.MenuItem
              className="admin-drop-header-menuitem"
              onClick={() => {
                generateText("1920x1080");
                handleClose();
              }}
            >
              1920 x 1080
            </Index.MenuItem>
          </Index.Menu>
        </Index.Box>
      </Index.Box>

      <Index.Box className="common-card">
        <Index.Box className={`page-table-main`}>
          <Index.TableContainer
            component={Index.Paper}
            className="table-container"
          >
            {loading ? (
              <PagesIndex.Loader />
            ) : (
              <Index.Table aria-label="simple table" className="table">
                <Index.TableHead className="table-head">
                  <Index.TableRow className="table-row">
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="8%"
                    >
                      Date
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Slot Timing
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="3%"
                    >
                      Priority
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="8%"
                    >
                      Code
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Client
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Advertisement
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Element
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="2%"
                    >
                      Duration
                    </Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {renderContent()}
                </Index.TableBody>
              </Index.Table>
            )}
          </Index.TableContainer>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
}
